import React from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./error.css";

const E403 = () => {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  return (
    <div className="error-container">
      <div className="error-content">
        <div className="error-code">403</div>
        <div className="error-message">Unauthorized Access</div>
        <Link to={isAuthenticated  ? "/home" :"/"}>BACK TO HOME</Link> 
        
      </div>
      
    </div>
  );
};

export default E403;
